import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/background-img.png";
import aboutInfo from "../../assets/images/lab.jpg";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Crafting Digital Experiences, Empowering Your Vision</title>
      </Helmet>
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"About us"}
        subtitle={"Our Expertise. Know more about what we do"}
      />
      <div className="">
        <div className="about-area pt-80">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <div
                  className={`ml-about-content service-animate ${
                    inView1 ? "visible" : ""
                  }`}
                  ref={ref1}
                >
                  <h2 className="mb-4">Your experience is everything to us </h2>
                  <p>
                    At <b>Elementeers</b>, we specialize in providing
                    high-quality laboratory solutions for critical trace element
                    analysis. With a focus on <b>Ultra Trace Metal Acids,</b>{" "}
                    <b>Ultra-Pure Solvents,</b> and{" "}
                    <b>ICP and ICPMS Standards,</b> we ensure the highest levels
                    of precision for analytical testing. Our range of products
                    includes <b>Tuning Standard Solutions,</b>{" "}
                    <b>Multi-Element Solutions,</b> and{" "}
                    <b>Customized Standard Solutions,</b> all designed to meet
                    the specific needs of research, quality control, and
                    industrial applications.
                  </p>
                  <p>
                    We are committed to delivering <b>chemicals and reagents</b>{" "}
                    of the highest purity and stability, enabling our clients in
                    fields such as pharmaceuticals, biotechnology, environmental
                    monitoring, and more to achieve accurate, reproducible
                    results. Our solutions are rigorously tested to meet
                    international standards, ensuring optimal performance in
                    advanced analytical instruments like <b>ICP, AAS,</b> and{" "}
                    <b>HPLC.</b>
                  </p>
                  <p>
                    Driven by innovation and reliability, <b>Elementeers</b> is
                    your trusted partner in precision chemistry and analytical
                    excellence
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="ml-about-img">
                  <img
                    alt="image"
                    loading="lazy"
                    width="100%"
                    decoding="async"
                    data-nimg="1"
                    src={aboutInfo}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="team-area mt-80 ptb-80 bg-f9f6f6">
            <div className="container">
              <div className="about-inner-area">
                <div className="row justify-content-center">
                  <div className="col-lg-6  col-md-6 col-sm-6">
                    <div className="lineright h-100 mx-auto">
                      <div
                        className={`about-text service-animate ${
                          inView2 ? "visible" : ""
                        }`}
                        ref={ref2}
                      >
                        <h3>Our History</h3>
                        <p>
                          With a passionate team of developers, designers, and
                          strategists, we specialize in creating dynamic,
                          user-friendly websites. Over the years, we’ve
                          partnered with diverse clients, delivering tailored
                          solutions that drive success and enhance online
                          presence.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="h-100 mx-auto">
                      <div
                        className={`about-text service-animate ${
                          inView3 ? "visible" : ""
                        }`}
                        ref={ref3}
                      >
                        <h3>Our Mission</h3>
                        <p>
                          At Element Standard Solution, our mission is simple:
                          to provide world-class standard solutions that empower
                          our clients to achieve precise and reliable results.
                          We strive to maintain the highest levels of quality,
                          service, and customer support, offering tailored
                          solutions to meet the specific needs of each client.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-6 col-sm-6">
                    <div
                      className={`about-text service-animate ${
                        inView4 ? "visible" : ""
                      }`}
                      ref={ref4}
                    >
                      <h3>Who We Are</h3>
                      <p>
                        We are a passionate team of web development experts
                        dedicated to crafting innovative and user-friendly
                        digital solutions. With a focus on collaboration,
                        creativity, and cutting-edge technology, we help
                        businesses thrive online by creating custom websites and
                        applications.
                      </p>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Cta />
    </div>
  );
};

export default AboutUs;
